export default __webpack_public_path__ + "static/media/Claudia_Peña_AHV_In_Moms_We_Trust.b0b233fc.jpg";